export const OfferHasExpired = {
	en: "We‘re sorry，the offer has expired.",
	cs: "Litujeme, nabídka vypršela.",
	da: "Vi beklager, men tilbuddet er udløbet.",
	de: "Es tut uns leid, das Angebot ist nicht mehr gültig.",
	el: "Λυπούμαστε, η προσφορά έχει λήξει.",
	es: "Lo sentimos, la oferta se ha terminado.",
	hr: "Žao nam je， ponuda je istekla.",
	fr: "Nous sommes désolés, l'offre a expiré.",
	hu: "Sajnáljuk, az ajánlat lejárt.",
	id: "Maaf, penawaran ini telah kedaluwarsa.",
	it: "Siamo spiacenti, l'offerta è scaduta.",
	ja: "大変申し訳ありません。有効期限が過ぎてしまいました。",
	ko: "죄송합니다. 쿠폰이 만료되었습니다.",
	nl: "Sorry, het aanbod is verlopen.",
	no: "Vi beklager, tilbudet har utløpt.",
	pl: "Przepraszamy, oferta wygasła.",
	pt: "Lamentamos, a oferta expirou.",
	ro: "Ne pare rău, oferta a expirat.",
	ru: "К сожалению, срок действия предложения истек.",
	sv: "Tyvärr, erbjudandet har gått ut.",
	th: "ขออภัย ข้อเสนอหมดอายุแล้ว",
	tr: "Üzgünüz, teklifin süresi doldu.",
	ar: "نأسف، انتهى العرض",
};
export const EndsIn = {
	en: "Starts On",
	cs: "Začíná dne",
	da: "Starter på",
	de: "Beginnt am",
	el: "Ξεκινά στις",
	es: "Comienza en",
	hr: "Započinje",
	fr: "Commence le",
	hu: "Kezdődik",
	id: "Mulai",
	it: "Comincia il",
	ja: "開始日",
	ko: "시작",
	nl: "Begint op",
	no: "Starter den",
	pl: "Rozpoczęcie",
	pt: "Começa Em",
	ro: "Începe în",
	ru: "Начало:",
	sv: "Börjar den",
	th: "เริ่มใน",
	tr: "Başlama Zamanı",
	ar: "العرض يبدأ في",
};
export const StartsOn = {
	en: "Starts On",
	cs: "Začíná dne",
	da: "Starter på",
	de: "Beginnt am",
	el: "Ξεκινά στις",
	es: "Comienza en",
	hr: "Započinje",
	fr: "Commence le",
	hu: "Kezdődik",
	id: "Mulai",
	it: "Comincia il",
	ja: "開始日",
	ko: "시작",
	nl: "Begint op",
	no: "Starter den",
	pl: "Rozpoczęcie",
	pt: "Começa Em",
	ro: "Începe în",
	ru: "Начало:",
	sv: "Börjar den",
	th: "เริ่มใน",
	tr: "Başlama Zamanı",
	ar: "العرض يبدأ في",
};

export const ErrorMessage = {
	en: "Sorry, this page is not available. Please find other products you may also like.",
	cs:
		"Je nám líto, tato stránka není dostupná. Najděte si prosím jiné produkty, které by se Vám mohly také líbit.",
	da: "Beklager, siden er ikke tilgængelig. Find venligst andre produkter du kan lide.",
	de:
		"Leider ist diese Seite nicht verfügbar. Stöbern Sie auf anderen Produktseiten nach Ihren Lieblingsteilen.",
	el:
		"Λυπούμαστε, αυτό το κουπόνι δεν είναι διαθέσιμο στη χώρα σας. Βρείτε άλλα προϊόντα που μπορεί να σας αρέσουν.",
	es:
		"Lo sentimos, esta página no está disponible. Encuentra otros productos que también te puedan gustar.",
	hr:
		"Nažalost, ova stranica nije dostupna. Pronađite druge proizvode koji bi vam se također mogli svidjeti.",
	fr:
		"Désolé, cette page n'est pas disponible. Veuillez trouver d'autres produits qui pourraient vous plaire.",
	hu: "Elnézést, az oldal nem elérhető. Kérjük, keressen más, kedvére való terméket.",
	id: "Maaf, halaman ini tidak tersedia. Silakan temukan produk lain yang mungkin Anda sukai.",
	it:
		"Siamo spiacenti, questa pagina non è disponibile. Ti invitiamo a trovare altri prodotti che potrebbero interessarti.",
	ja: "お探しのページがみつかりません。似たような商品をお探しください。",
	ko: "죄송합니다. 이 페이지를 찾을 수 없습니다. 다른 제품들을 확인하시기 바랍니다. ",
	nl:
		"Sorry, deze pagina is niet beschikbaar. Vind andere producten die je misschien ook leuk vindt.",
	no:
		"Beklager, denne siden er ikke tilgjengelig. Finn andre produkter du kanskje også vil like.",
	pl:
		"Przepraszamy, ta strona jest niedostępna. Poszukaj innych produktów, które mogą Ci się spodobać.",
	pt:
		"Desculpe, esta página não está disponível. Selecionamos outros produtos que talvez te interesse também.",
	ro: "Ne pare rău, această pagină nu este disponibilă. Vă rugăm să găsiți alte produse.",
	ru:
		"К сожалению, эта страница недоступна. Пожалуйста, обратите внимание на другие товары, которые вам также могут понравиться.",
	sv:
		"Tyvärr, denna sida är inte tillgänglig. På vår sida kan du hitta många andra produkter som du kanske också gillar.",
	th: "ขออภัย ไม่สามารถใช้งานหน้านี้ได้ โปรดค้นหาสินค้าอื่นที่คุณอาจจะชอบเหมือนกัน",
	tr: "Üzgünüz, bu sayfa kullanılamıyor. Burada beğenebileceğiniz diğer ürünler bulabilirsiniz.",
	ar: "عفوًا، هذه الصفحة غير متاحة. برجاء البحث عن منتجات أخرى قد تنال إعجابك.",
};

export const GoShopping = {
	en: "Go Shopping",
	cs: "Jít nakupovat",
	da: "Tag På Shopping",
	de: "Los geht's mit dem Shoppen",
	el: "Πηγαίνετε για ψώνια",
	es: "Anda de compras",
	hr: "Započni kupovinu",
	fr: "Aller Faire du Shopping",
	hu: "Induljon a bevásárlás",
	id: "Pergi Berbelanja",
	it: "Continua gli acquisti",
	ja: "ショッピングする",
	ko: "쇼핑하기",
	nl: "Ga winkelen",
	no: "Gå på shopping",
	pl: "Czas na zakupy",
	pt: "Va às compras!",
	ro: "Mergeți la Cumpărături",
	ru: "За покупками",
	sv: "Shoppa",
	th: "ไปชอปปิง",
	tr: "Alışverişe Gidin",
	ar: "اذهب للتسوق",
};
export const ViewMore = {
	en: "View More",
	cz: "Zobrazit více",
	da: "Se mere",
	de: "Mehr anzeigen",
	gr: "Δείτε περισσότερα",
	es: "Ver más",
	hr: "Vidi više",
	fr: "Voir Plus",
	hu: "Tovább",
	it: "Vedi altro",
	ja: "もっと見る",
	ko: "더보기",
	nl: "Meer weergeven",
	no: "Se mer",
	pl: "Zobacz więcej",
	pt: "Ver Mais",
	ro: "Vezi Mai Multe",
	ru: "Подробнее",
	sv: "Visa mer",
	th: "ดูเพิ่ม",
	tr: "Daha Fazla Göster",
	ar: "مشاهدة المزيد",
	he: "ראה עוד",
	id: "lihat lebih banyak",
	fi: "Katso lisää",
};
